import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid, Paper, Slider, Typography } from "@mui/material";
import ICardGroupItem from "../../../types/ICardGroupItem";
import { styled } from "@mui/material/styles";
import { getLanguage } from "../../../utils/languagePicker";
import {
  TextField
} from "@mui/material";

const PrettoSlider = styled(Slider)(({ theme }) => ({
  color: theme.palette.primary.light,
  height: 6,
  borderRadius: theme.shape.borderRadius,
  "& .MuiSlider-track": {
    border: "none"
  },
  "& .MuiSlider-thumb": {
    height: 24,
    width: 24,
    backgroundColor: theme.palette.common.white,
    border: "1px solid currentColor",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: `0px 0px 10px 6px ${theme.palette.primary.light}33`
    },
    "&:before": {
      display: "none"
    }
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1,
    fontSize: "1rem",
    background: "unset",
    padding: 0,
    width: 36,
    height: 36,
    borderRadius: "50% 50% 50% 0",
    backgroundColor: theme.palette.primary.light,
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&:before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: "translate(50%, -100%) rotate(-45deg) scale(1)"
    },
    "& > *": {
      transform: "rotate(45deg)"
    }
  }
}));

const TrainerRideGroupItem = ({
  item,
  points,
  currentPoints,
  onPoint,
  comment,
  onComment
}: {
  item: ICardGroupItem;
  points: number;
  currentPoints: number;
  onPoint: (points: number) => void;
  comment: string;
  onComment: (comment: string) => void;
}): JSX.Element => {
  const { t } = useTranslation();
  const [value, setValue] = useState<number>(currentPoints);
  // useEffect(() => {
  //   onPoint(value);
  // }, [value]);

  return (
    <>
    <Paper square={false}>
      <Grid>
        <Grid container spacing={2} p={2}>
          <Grid item md={8} xs={12}>
            <Typography variant="body1">{item.name[getLanguage()]}</Typography>
          </Grid>
          <Grid item md={1} xs={12}></Grid>
          <Grid item md={3} xs={8} display={"flex"} alignItems={"center"}>
            <PrettoSlider
              valueLabelDisplay="auto"
              aria-label={t("Ocena")}
              track={false}
              step={1}
              marks
              min={0}
              max={points}
              sx={{ mr: 2 }}
              value={value}
              onChange={(event, value) => {
                setValue(value as number);
                onPoint(value as number);
              }}
              onChangeCommitted={(event, value) => {
                onPoint(value as number);
              }}
            />
          </Grid>
        </Grid>
        <Grid container sx={{ mt: -2 }}>
          <TextField
            value={comment}
            onChange={(e) => {onComment(e.target.value)} }
            rows={3}
            multiline
            placeholder={`${t("Komentarz")}...`}
            sx={{ p: 2, width: '76%' }}
          />
        </Grid>
      </Grid>
    </Paper>
    </>
  );
};

export default TrainerRideGroupItem;
